import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.2377 6.66L14.6816 1.71L14.1954 1.5H3.47187L2.77734 2.25V10.5H4.1664V3H12.5008V8.25L13.1953 9H18.057V10.5H19.4461V7.2L19.2377 6.66ZM13.8898 7.5V3L18.057 7.5H13.8898ZM3.47187 12L2.77734 12.75V21.75L3.47187 22.5H18.7515L19.4461 21.75V12.75L18.7515 12H3.47187ZM18.057 19.5V21H4.1664V13.5H18.057V19.5Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.89061 15.5714C8.80653 15.5714 9.37959 16.0465 9.37959 16.8155C9.37959 17.5796 8.80653 18.0547 7.89061 18.0547H7.2V19H6.40653V15.5714H7.89061ZM7.84653 17.4082C8.33143 17.4082 8.57633 17.1878 8.57633 16.8155C8.57633 16.4384 8.33143 16.218 7.84653 16.218H7.2V17.4082H7.84653ZM11.4302 15.5714C12.3461 15.5714 12.9191 16.0465 12.9191 16.8155C12.9191 17.5796 12.3461 18.0547 11.4302 18.0547H10.7395V19H9.94607V15.5714H11.4302ZM11.3861 17.4082C11.871 17.4082 12.1159 17.1878 12.1159 16.8155C12.1159 16.4384 11.871 16.218 11.3861 16.218H10.7395V17.4082H11.3861ZM14.1002 19V16.218H13.003V15.5714H15.9908V16.218H14.8936V19H14.1002Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }